import Button from '@/components/elements/forms/buttons/Button/Button';
import PopupShell from '../PopupShell/PopupShell';

type PopupTerminalCardProps = { title?: string; body: string; closeLabel?: string };

// Announced when it appears (it replaces a spinner on every page that renders it)
// and lands focus on the way out.
const PopupTerminalCard = ({ title, body, closeLabel }: PopupTerminalCardProps) => (
  <PopupShell>
    <div className="gap-md flex flex-col">
      <div role="alert" className="gap-md flex flex-col">
        {title && <h2 className="text-fg_primary text-h-m">{title}</h2>}
        <p className="text-fg_primary text-l">{body}</p>
      </div>
      {closeLabel && (
        <Button block variant="primary" size="md" autoFocus onClick={() => window.close()}>
          {closeLabel}
        </Button>
      )}
    </div>
  </PopupShell>
);

export default PopupTerminalCard;
